// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-select-file[data-v-42a94c8a] {\n  width: 0px;\n  visibility: hidden;\n}\n.btn-upload[data-v-42a94c8a] {\n  font-weight: 300;\n  border-radius: 0.5em;\n  background-color: #e5eaec;\n}\n.btn-upload[disabled=disabled][data-v-42a94c8a] {\n  color: #c1c1c1;\n  cursor: not-allowed;\n  background-color: #e5eaec90;\n}", ""]);
// Exports
module.exports = exports;
